module.exports = __webpack_public_path__ + "static/media/iStock.b6b6bc66.jpg";